import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import DataTable from './DataTable';
import {
  addAdminProduct,
  deleteAdminVariant,
  getAdminProducts,
  getAdminVariants,
  getResourceFile,
  updateAdminOrder,
  updateAdminProduct,
  updateAdminProductVariants
} from '../../network';
import { formatPrice } from '../../helpers/Helper';
import _ from 'lodash';
import { differenceBetweenTime } from '../../utils/formatter';
import ProductEditComponent from './ProductEditComponent';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: calc(100% - 14.75rem);
  height: 100vh;
  //height: 100%;
  
  padding: 1rem 1.5rem 0 1.5rem;
`;

const PageHeader = styled.h1`
  height: 1.25rem;
  font-size: 1.25rem;
  line-height: 1.25rem;
  
  font-family: OpticianSans, serif;
  font-style: normal;
  font-weight: normal;
  
  color: var(--color-gray-500);
`;

const ContentContainer = styled.div`
  position: relative;
  width: 100%;
  height: -webkit-fill-available;
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;
`;

const TagGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: var(--space-24);
  > div {
    margin-bottom: 0.5rem;
  }
`;

const Tag = styled.div`
  display: flex;
  width: fit-content;
  padding: var(--space-4) var(--space-6);

  font-size: var(--font-12);
  font-weight: 500;
  color: ${props => props.color ? `var(--color-${props.color}-800)` : ''};
  background-color: ${props => props.color ? `var(--color-${props.color}-100)` : ''};
  box-shadow: ${props => props.color ? `0 0 0 1px var(--color-${props.color}-300)` : '0 0 0 1px #C8E1D2'};
  border-radius: var(--space-4);
`;

const Label = styled.span`
  color: var(--color-gray-600);
  width: 6rem;
`;

const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-bottom: 1rem;
  > a {
    color: var(--company-dark);
    font-weight: 500;
    width: 12.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &:last-of-type {
      margin-bottom: var(--space-28); 
    }
`;

const ActionsBar = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  justify-content: space-between;
  padding-top: var(--space-16);
  padding-left: var(--space-20);
  padding-right: var(--space-20);
  padding-bottom: var(--space-8);
  border-top: 1px solid var(--color-gray-300);
  > button {
    border: none;
    box-shadow: none;
    background: none;
    padding: var(--space-6) var(--space-8);
    border-radius: var(--space-4);
    color: var(--company-dark);
    font-size: var(--font-16);
    font-weight: normal;
    &:hover {
      background-color: var(--color-gray-200);
      transition: background-color 0.3s ease-in;
    }
    &:last-of-type {
      color: var(--color-red-700);
    }
  }
`;

const InnerDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  //height: calc(100% - var(--space-32));
  height: -webkit-fill-available; // desperation
  line-height: 1.2;
  vertical-align: center;
  font-size: var(--font-14);
  
  margin: 1rem 0 1rem 0;
  //padding: 1.5rem 1.5rem 0.5rem 1.5rem;
  padding: 1.5rem 0 0.5rem 0;
  
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.12);
  border-radius: 0.25rem;
  
  overflow-y: hidden;

  background: white;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  
  padding: 0 1.5rem 0 1.5rem;
  
  justify-content: space-between;
  align-items: center;
`;

const FilterSection = styled.div`
  display: flex;
  align-items: center;
  
  > span {
    height: 0.875rem;
    
    
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
    color: var(--color-gray-600);
  }
`;

const Dropdown = styled.div`
  border: 1px solid var(--color-gray-300);
  box-sizing: border-box;
  border-radius: 1.5rem;
  
  margin: 0 0 0 1rem;
  padding: 0 0.75rem 0 0.75rem;
  
  > select {
    height: 1.5rem;
    
    background: transparent;
    
    border: 0;
  
    appearance: none;
    outline: none;

    
    font-size: 0.75rem;
    font-weight: 500;
    
    color: var(--color-gray-800);
  }
  
  > img {
    margin-left: var(--space-8);
  }
`;

const SearchSection = styled.div`
  display: flex;
  align-items: center;
  width: 30%;
  
  > img {
    position: relative;
    left: 90%;
  }
  
  > input {
    width: 100%;
    height: 1.875rem;
    
    padding: 1rem;
    background: white;
    
    border: 1px solid var(--color-gray-300);
    box-sizing: border-box;
    border-radius: 4px;
    
    color: var(--color-gray-500);
    
    font-style: normal;
    font-weight: normal;
    font-size: 0.875rem;
    line-height: 0.875rem;
  }
`;

const CellText = styled.span`
  width: 90%;
  
  
  font-style: normal;
  //font-weight: 500;
  font-size: 0.875rem;
  line-height: 1rem;

  color: var(--color-gray-900);
  
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StockContainer = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;
  
  > span {
    
    font-style: normal;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 0.875rem;

    color: var(--color-gray-900);
  }
  
  > .slider-track {
    width: 40%;
    height: var(--space-4);
    
    margin-top: var(--sapce-4);
    
    border-radius: var(--sapce-2);
    
    background: var(--color-gray-700);
    
    > .slider {
      width: ${props => props.percentage ? `${props.percentage}%` : '0%'};
      height: inherit;
      
      border-radius: var(--space-2);
      
      background: var(--color-yellow-500);
    }
  }
`;

const DetailStockContainer = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: center;
  align-items: center;
  
  > span {
    
    font-style: normal;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 0.75rem;

    color: var(--color-gray-600);
    
    &:first-of-type {
      margin-right: var(--space-8);
    }
    
    &:last-of-type {
      margin-left: var(--space-8);
    }
  }
  
  > .slider-track {
    position: relative;
    width: var(--space-64);
    height: var(--space-4);
    
    //margin-top: 4px;
    
    border-radius: var(--space-2);
    
    background: var(--color-gray-700);
    
    > .slider {
      width: ${props => props.percentage ? `${props.percentage}%` : '0%'};
      height: inherit;
      
      border-radius: var(--space-2);
      
      background: var(--color-yellow-500);
    }
    
    > .stroke {
      position: absolute;
      width: 1px;
      height: inherit;
      
      top: 0;
      left: 0;
      background: var(--color-gray-300);
    }
  }
`;

const AddProductButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  
  height: 1.25rem;

  font-size: 0.75rem;
  line-height: 0.75rem;
  //padding: 10px;
  
  color: white;

  border: none;
  background: var(--color-orange-600) none;
  box-shadow: 0 var(--space-4) var(--space-6) rgba(221, 107, 32, 0.12), 0 var(--space-2) var(--space-4) rgba(221, 107, 32, 0.08);
  border-radius: 0.25rem;
  
  cursor: pointer;
  
  &:hover {
    background: var(--color-orange-500);
    transition: background-color 0.3s ease-in;
  }
`;

const DetailHeaderBrand = styled.div`
  color: var(--color-gray-900);
  
  
  font-size: 0.875rem;
  font-style: normal;
  font-weight: normal;
  line-height: 0.875rem;
  
  margin-top: 0.5rem;
  margin-left: var(--space-24);
`;

const DetailHeaderProduct = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: var(--space-24);
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  
  
  font-weight: 500;
  font-size: 1.125rem;
  line-height: 1.375rem;
    
  color: var(--color-gray-900);
`;

const Divider = styled.div`
  width: calc(100% - var(--space-48));
  margin-top: var(--space-8);
  margin-bottom: var(--space-24);
  margin-left: var(--space-24);
  height: 1px;
  background-color: var(--color-gray-300);
`;

const SectionTitle = styled.span`
  margin-left: var(--space-24);
  margin-bottom: var(--space-16);
  
  font-size: 0.75rem;
  line-height: 0.75rem;
  font-weight: 500;
  color: var(--color-gray-600);
`;

const LineItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  //align-items: baseline;
  justify-content: space-between;
  
  width: calc(100% - var(--space-48));
  margin-left: var(--space-24);
`;


const ProductImageContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;

	width: var(--space-64);
    height: var(--space-64);

	background: white;


	> .close {
		display: flex;
		align-items: center;
		justify-content: center;
		position: absolute;

		width: var(--space-24);
		height: var(--space-24);

		font-size: var(--font-12);
		line-height: var(--font-12);
		color: var(--color-gray-700);

		background: var(--color-gray-100);
		border: 1px solid var(--color-gray-600);
		box-sizing: border-box;

		border-radius: var(--space-20);
		left: 3.25rem;
        top: 3.25rem;

		cursor: pointer;
	}
	
	> .badge {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        
        width: auto;
        height: var(--space-18);
        min-width: var(--space-18);
        
        font-size: var(--font-12);
        line-height: var(--font-12);
        
        background: white;
        border: 1px solid var(--color-gray-500);
        box-sizing: border-box;
        box-shadow: none;
        
        border-radius: 0.625rem;
        left: 3.25rem;
        top: 3.25rem;
        margin: 0;
    }

	> div.image-container {
	    display: flex;
        align-items: center;
        justify-content: center;
    
		width: 100%;
		height: 100%;

		overflow: hidden;

		border: 1px solid var(--color-gray-300);
		box-sizing: border-box;
		border-radius: var(--space-8);

		> img {
			width: 100%;
			object-fit: cover;
		}

		> video {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		
        > span {
            display: flex;
            align-items: center;
            justify-content: center;
            
            width: 100%;
            height: 100%;
            
            background: var(--color-gray-100);
            border-radius: 0.5rem;
            
            color: var(--color-gray-700);
            
            font-size: 0.75rem;
            line-height: 0.75rem;
            font-weight: 500;
        }
	}
`;

const ProductStock = styled.div`
  display: flex;
  align-items: baseline;
  
  color: var(--color-gray-800);
  
  > span {
    font-size: var(--font-16);
    line-height: var(--font-16);
  }
  
  .amount {
    font-size: var(--font-24);
    line-height: var(--font-24);
    margin-right: var(--space-8);
  }
`;

const ProductPricing = styled.div`
  display: flex;
  align-items: baseline;
  
  color: var(--color-gray-700);
  
  > span {
    font-weight: 500;
  }
  
  .amount {
    font-size: var(--font-16);
    line-height: var(--font-16);
    margin-left: var(--space-4);
    margin-right: var(--space-4);
  }
  
  .lower {
    font-size: var(--font-12);
    line-height: var(--font-12);
  }
`;

const ProductSpecifications = styled.span`
  color: var(--color-gray-500);
  font-size: var(--font-14);
  line-height: var(--font-14);
  font-weight: 500;
`;

const ProductSaleExpiration = styled.span`
  color: var(--color-gray-500);
  font-size: var(--font-14);
  line-height: var(--font-14);
  font-weight: 500;
`;

const MasterContainer = styled.div`
  //height: -webkit-fill-available;
  height: calc(100vh - 2.5rem); // desperation
  flex-grow: 1;
  margin-right: 1.5rem;
`;

const DetailContainer = styled.div`
  width: 24rem;
  height: calc(100vh - 4.5rem); // desperation
`;

function BackOfficeProducts({ auth }) {
  const [products, setProducts] = useState([]);
  const [toggleP, setToggleP] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [sort, setSort] = useState(null);
  const [filter, setFilter] = useState('');
  const [details, setDetails] = useState(null);
  const [detailsEdit, setDetailsEdit] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(25);
  const [pageCount, setPageCount] = useState(1);
  const [saleExpiration, setSaleExpiration] = useState(null);
  const [saleExpirationInterval, setSaleExpirationInterval] = useState(null);

  const adminToken = auth ? auth.token : null;

  const filters = [
    {
      value: 'instock',
      text: 'In Stock'
    },
    {
      value: 'outofstock',
      text: 'Out Of Stock'
    },
    {
      value: 'onspecial',
      text: 'On Special'
    }
  ];
  const headers = [
    {
      title: 'Product ID',
      sortable: true,
      sort: 'order_number'
    }, { title: 'Product Name' }, {
      title: 'Stock Level',
      center: true,
      sortable: true,
      sort: 'stock'
    }, { title: 'Brand' }, {
      title: 'Default Price',
      sortable: true,
      sort: 'price'
    }
  ];

  useEffect(() => search(searchText), [searchText, currentPage, sort, filter]);

  const search = searchText => {
    getAdminVariants(adminToken, searchText, currentPage, pageLimit, sort, null)
      .then(result => {
        setDetails(null);
        setDetailsEdit(null);
        setProducts([...result.data]);
        setPageCount(Math.ceil(result.total / pageLimit));
      })
      .catch(error => console.error(error));
  };

  const removeProductVariant = (productId, variantId) => {
    deleteAdminVariant(adminToken, productId, variantId)
      .then(() => {
        setDetails(null);
        setDetailsEdit(null);
        search(searchText);
      })
      .catch(error => console.error(error));
  };

  const changeSort = sort => setSort(sort);

  const changePage = direction => {
    if (currentPage === 1 && direction < 0) return;
    if (currentPage === pageCount && direction > 0) return;

    setProducts([]);
    setCurrentPage(currentPage + (direction));
  };

  const debouncedSearchText = _.debounce(query => {
    setSearchText(query);
  }, 400);

  const handleChange = e => {
    const value = e.target.value.trim();
    debouncedSearchText(value);
  };

  // useEffect(() => {
  //     if (!details) return;
  //     if (details.discount === 0 || details.discount_expiration === 0) return;
  //
  //     const interval = setInterval(() => {
  //         setSaleExpiration(differenceBetweenTime(details.discount_expiration));
  //     }, 1000);
  //     return () => clearInterval(interval);
  // }, [details]);

  const onRowSelect = data => {
    const details = { ...data };
    // setSaleExpirationInterval(null);
    // clearInterval(saleExpirationInterval);
    // saleExpirationInterval = null;

    console.log(details);
    setDetails(details);
    setDetailsEdit(null);
    setSaleExpiration(null);

    // if (details.discount !== 0 && details.discount_expiration !== 0) {
    //     setSaleExpirationInterval(setInterval(() => setSaleExpiration(differenceBetweenTime(details.discount_expiration)), 1000));
    // }
  };

  const calculateStockPercentage = (stock, max) => {
    let percentage = (stock / max) * 100;
    if (percentage < 0) percentage = 0;
    if (percentage > 100) percentage = 100;

    return percentage;
  };

  const dataRows = data => {
    let rows = [];

    data.map(item => {
      const stockPercent = calculateStockPercentage(item.stock, item.max_stock);
      rows.push({
        onRowSelect,
        data: item,
        view: <>
          <CellText>{item.order_number}</CellText>
          <CellText>{item.product.name}{item.description ? ` - ${item.description}` : ''}</CellText>
          <StockContainer percentage={stockPercent}>
            <span>{item.stock}</span>
            <div className="slider-track">
              <div className="slider" />
            </div>
          </StockContainer>
          <CellText>{item.product.brand.name}</CellText>
          <CellText>{formatPrice(item.price)}</CellText>
        </>
      });
    });
    return rows;
  };

  const retrieveAllMedia = variant => [...variant.media, ...variant.product.media];

  const handleEditChange = e => {
    const { value, name } = e.target;
    setDetailsEdit({
      ...detailsEdit,
      [name]: value
    });
  };

  const saveProductEntry = (details, permutations, exceptions) => {

    const { product } = details;
    const {
      _id,
      name,
      brand_id,
      aliases,
      tags,
      description,
      description_html,
      features,
      features_html,
      media,
      price,
      attribute_name,
      size_name,
      min_stock,
      price_toggle
    } = product;

    let variants = [...exceptions, ...permutations];
    variants = variants.filter((variant, index, self) => index === self.findIndex((v) => v.value === variant.value));
    console.log('variants', variants);
    // return;

    if (_id) {
      updateAdminProduct(adminToken, _id, {
        brand_id,
        aliases,
        tags,
        description,
        description_html,
        features,
        features_html,
        media,
        price,
        attribute_name,
        size_name,
        min_stock,
        price_toggle
      })
        .then(() => {
          updateAdminProductVariants(adminToken, _id, variants)
            .then(() => {
              setDetails(null);
              setDetailsEdit(null);
              search(searchText);
            })
            .catch(error => console.error(error));
        })
        .catch(error => console.error(error));
    } else {
      // add new product
      addAdminProduct(adminToken, {
        name,
        brand_id,
        aliases,
        tags,
        description,
        description_html,
        features,
        features_html,
        media,
        price,
        attribute_name,
        size_name,
        min_stock,
        price_toggle
      })
        .then(result => {
          variants.map(variant => {
            if (!variant.price) variant.price = price;
          });

          updateAdminProductVariants(adminToken, result._id, variants)
            .then(() => {
              setDetails(null);
              setDetailsEdit(null);
              search(searchText);
            })
            .catch(error => console.error(error));
        })
        .catch(error => console.error(error));
    }
  };

  const deleteProductEntry = details => {
    console.log(details);
    // removeProductVariant(details.product_id, details._id);
  };

  const evalPrimaryAction = () => {
    if (!detailsEdit) setDetailsEdit({ ...details });
    else {
      // eval if valid information entered, collect updates and update product and/or variant
      // updateAdminVariant(adminToken, detailsEdit._id, detailsEdit)
      //     .then(result => search(searchText))
      //     .catch(error => console.error(error));
    }
  };

  const evalSecondaryAction = () => {
    if (detailsEdit) setDetailsEdit(null);
    else removeProductVariant(details.product_id, details._id);
  };

  console.log("seeeee", details);

  return (
    <Container>
      {
        !detailsEdit ?
          <>
            <MasterContainer>
              <PageHeader>PRODUCTS</PageHeader>
              <ContentContainer>
                <Row style={{ marginBottom: '1rem' }}>
                  <FilterSection>
                    <span>Filter by</span>

                    <Dropdown>
                      <select value={filter} onChange={e => setFilter(e.target.value)}>
                        <option value=''>All</option>
                        {
                          filters.map((filter, index) => {
                            return <option key={`BackofficeProductsFilterOption_${index}`} value={filter.value}>{filter.text}</option>;
                          })
                        }
                      </select>
                      <img alt='dropdown' src='/icons/chevron.svg' />
                    </Dropdown>
                  </FilterSection>

                  <SearchSection>
                    <img src='/icons/search.svg' alt='search icon' />
                    <input placeholder='Search here...' type='text' onChange={handleChange} />
                  </SearchSection>

                  <AddProductButton onClick={() => setDetailsEdit({
                    product: {
                      aliases: [],
                      tags: [],
                      variants: [],
                      media: [],
                      price: 1,
                      min_stock: 1
                    }
                  })}>Add New Product</AddProductButton>
                </Row>

                <DataTable
                  headers={headers}
                  rows={dataRows(products)}
                  changeSort={changeSort}
                  spacing={'15% 40% 15% 15% 15%'}
                  currentPage={currentPage}
                  pageCount={pageCount}
                  pageBack={() => changePage(-1)}
                  pageNext={() => changePage(1)}
                />
              </ContentContainer>
            </MasterContainer>

            {
              details && <DetailContainer>
                <PageHeader>DETAILS</PageHeader>
                <InnerDetailContainer>
                  <DetailHeaderBrand>{details.product.brand.name}</DetailHeaderBrand>
                  <DetailHeaderProduct>{details.product.name}{details.description ? ` - ${details.description}` : ''}</DetailHeaderProduct>
                  <TagGroup>
                    <Tag color="gray">
                      {`Attribute (${details.product.attribute_name || 'N/A'}): ${details.attribute || 'N/A'} | Size (${details.product.size_name || 'N/A'}): ${details.size || 'N/A'}`}
                    </Tag>
                    {
                      details.product.tags.length > 0 ?
                        <Tag color="gray">
                          {`${details.product.tags[0]}${details.product.tags.length > 1 ? `, +${details.product.tags.length - 1} more Tags` : ' Tags'}`}
                        </Tag>
                        : <Tag color="gray">No Tags</Tag>
                    }
                    {
                      details.product.aliases.length > 0 ?
                        <Tag color="gray">
                          {`${details.product.aliases[0]}${details.product.aliases.length > 1 ? `, +${details.product.aliases.length - 1} more Aliases` : ' Aliases'}`}
                        </Tag>
                        : <Tag color="gray">No Aliases</Tag>
                    }
                  </TagGroup>
                  <Divider />
                  <SectionTitle>Product Media</SectionTitle>
                  <LineItemContainer>
                    {
                      retrieveAllMedia(details)
                        .map((media, index) => {
                          return index < 3 && <ProductImageContainer key={`ProductImageContainer_${index}`}>
                            <div className="image-container">
                              {media.type === 'image' && <img src={getResourceFile(media.resource)} alt="productImage" />}
                              {media.type === 'video' && <video src={getResourceFile(media.resource)} controls />}
                            </div>
                          </ProductImageContainer>;
                        })
                    }
                    {
                      retrieveAllMedia(details).length > 3 ? <ProductImageContainer>
                        <div className="image-container">
                          <span>+{retrieveAllMedia(details).length - 3} more</span>
                        </div>
                      </ProductImageContainer> : null
                    }
                  </LineItemContainer>
                  <Divider />
                  <SectionTitle>Product Stock</SectionTitle>
                  <LineItemContainer>
                    <ProductStock>
                      <span className="amount">{details.stock}</span>
                      <span>units</span>
                    </ProductStock>
                    <DetailStockContainer percentage={calculateStockPercentage(details.stock, details.max_stock)}>
                      <span>0</span>
                      <div className="slider-track">
                        <div className="slider" />
                        {
                          [1, 2, 3, 4].map((stroke, index) => {
                            return <div className="stroke" key={`StockSliderStroke_${index}`} style={{
                              left: `calc(${stroke} * var(--space-12))`
                            }} />;
                          })
                        }
                      </div>
                      <span>{details.max_stock}</span>
                    </DetailStockContainer>
                  </LineItemContainer>
                  <Divider />

                  {details.product.price_toggle && (
                    <>
                      <SectionTitle>Product Pricing</SectionTitle>
                      {console.log("regreg", details.product.price_toggle)}

                      <LineItemContainer>
                        <ProductPricing>
                          <span className="lower">$</span>
                          <span className="amount">{formatPrice(details.price, false, false)}</span>
                          <span className="lower">initial</span>
                        </ProductPricing>
                        {
                          (details.attribute || details.size) &&
                          <ProductSpecifications>{details.attribute ? details.attribute : ''}{details.size ? details.attribute ? `, ${details.size}` : details.size : ''}</ProductSpecifications>
                        }
                      </LineItemContainer>
                    </>
                  )}
                  {
                    saleExpiration && <LineItemContainer style={{
                      marginTop: 'var(--space-24)',
                      alignItems: 'center'
                    }}>
                      <Tag color="orange">On Sale ({details.discount}%)</Tag>
                      <ProductSaleExpiration>{saleExpiration}</ProductSaleExpiration>
                    </LineItemContainer>
                  }
                  <ActionsBar>
                    <button onClick={evalPrimaryAction}>{detailsEdit ? 'Save Product' : 'Edit Product'}</button>
                    <button onClick={evalSecondaryAction}>{detailsEdit ? 'Cancel' : 'Delete'}</button>
                  </ActionsBar>
                </InnerDetailContainer>
              </DetailContainer>
            }
          </>
          :
          <ProductEditComponent
            details={detailsEdit}
            setDetailsEdit={setDetailsEdit}
            saveProductEntry={saveProductEntry}
            deleteProductEntry={deleteProductEntry}
          />
      }
    </Container>
  );
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user
});

export default connect(mapStateToProps, null)(BackOfficeProducts);
